<template>
  <div>
    <label :for="id">{{ label }}</label>
    <v-color-picker
      v-model="selectedColor"
      :hide-canvas="true"
      :hide-sliders="true"
      :hide-inputs="true"
      mode="hexa"
      :show-swatches="true"
      width="100%"
    />
  </div>
</template>

<script>
import { VColorPicker } from "vuetify/lib";

export default {
  components: {
    VColorPicker,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: "",
    },
  },
  methods: {
    resetColor() {
      this.selectedColor = "";
    },
  },
  data() {
    return {
      selectedColor: this.value,
    };
  },
  watch: {
    selectedColor(newColor) {
      this.$emit("input", newColor);
    },
    value(newValue) {
      this.selectedColor = newValue;
    },
  },
};
</script>
